import React from 'react';

export default function SpecialsSectionListItemSkeleton(): React.JSX.Element {
    return (
        <div className="relative flex-none w-[325px] h-[308px] rounded-8 border-2 border-[var(--surface-color)] animate-pulse-skeleton">
            <div className="h-[165px] lg:h-[192px] bg-[var(--surface-color)] flex-none animate-pulse-skeleton" />
            <div className="p-10 space-y-4">
                <div className="w-full h-[24px] bg-[var(--surface-color)] rounded-4 animate-pulse-skeleton" />
                <div className="w-1/2 h-[16px] bg-[var(--surface-color)] rounded-4 animate-pulse-skeleton" />
                <div className="w-full h-[36px] bg-[var(--surface-color)] rounded-4 animate-pulse-skeleton !mt-12" />
            </div>
        </div>
    );
}
